import type { ApplicationReportIn, MethodApplicationOut, MethodVersionOut, TerminalOutcome } from "@/api/types";

export interface ReportDraft {
  outcome?: TerminalOutcome;
  adaptations?: string;
  result?: string;
  limitations?: string;
  evidence?: string[];
  asVersion?: boolean;
  body?: string;
}

export function buildApplicationReport(application: MethodApplicationOut, draft: ReportDraft, applied?: MethodVersionOut): ApplicationReportIn {
  if (!draft.outcome) throw new Error("Выбери исход каждого применения метода");
  const report: ApplicationReportIn = {
    application_id: application.id, version: application.version, outcome: draft.outcome,
    adaptations_md: draft.adaptations?.trim() || null,
    result_md: draft.result?.trim() || null,
    limitations_md: draft.limitations?.trim() || null,
    evidence_entry_ids: draft.evidence ?? [],
    save_as_new_version: draft.asVersion ?? false, set_current: false,
  };
  if (draft.asVersion && draft.body !== undefined) {
    if (!applied) throw new Error("Дождись загрузки применённой версии");
    if (!draft.body.trim()) throw new Error("В новой версии должны остаться шаги решения");
    report.new_version = {
      body_md: draft.body.trim(), preconditions_md: applied.preconditions_md,
      checks_md: applied.checks_md,
      pitfalls_md: [applied.pitfalls_md, report.limitations_md].filter(Boolean).join("\n\n") || null,
    };
  }
  // Without an explicit edit the server derives the COMPLETE applied version,
  // appends limitations, and records adaptations as its change_note.
  return report;
}
